<div class="center_img">
    <img (click)="closePopup()" src="../../../assets/images/Vector.png" alt="NsureHub">
  </div>
  <div class="videoBox">
    <video controls poster="../../assets/images/nsurehub/howtovideobg.png">
        <source src="../../assets/videos/howto.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
  </div>